export default __webpack_public_path__ + "static/media/img_services02.ea02cb12.png";